module.exports = __webpack_public_path__ + "delete-c9008183449601f35f59.png";